// File naming convention for locale files:
// URL format: portal/<country>/<language>
// File name format: <language>_<country>.json

// German
import de_AT from './de_AT.json'; // Austria
import de_DE from './de_DE.json'; // Germany

// French
import fr_BE from './fr_BE.json'; // Belgium
import fr_FR from './fr_FR.json'; // France

// Italian
import it_IT from './it_IT.json';

// English
import en_IE from './en_IE.json'; // Ireland
import en_US from './en_US.json'; // United States

// Spanish
import es_ES from './es_ES.json'; // Spain

// This is the list of all available locales that your MFE supports
// You reuse the same locale file for multiple locales if they share the same translations

export default {
  de_AT,
  de_DE,
  fr_BE,
  fr_FR,
  it_IT,
  en_IE,
  en_US,
  es_ES
};
